import { render, staticRenderFns } from "./AcNotice.vue?vue&type=template&id=10ae82a7"
import script from "./AcNotice.vue?vue&type=script&lang=js"
export * from "./AcNotice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./admin/src/js/components/AcNotice.vue
// module id = 27
// module chunks = 0